export interface ClientDocument {
  id: string;
  fileCode: string;
  fileId: number | null;
  clientId: number | null;
  agentId: number | null;
  fileName: string;
  fileSize: number | null;
  fileType: string;
  fileContent: Uint8Array;
  timeUploaded: string | null;
  fileDesc: string;
  timePosted: string | null;
  dueDate: string | null;
  showInPortal: boolean | null;
  displayOrder: number;
  downloadedToMm: boolean;
  rejectedByAgent: boolean;
  rejectionReason: string;
  receivedOutsidePortal: boolean;
  timeDeleted: string | null;
  deletedBeforeDownloadToMm: boolean;
  timeDownloaded: string | null;
  zipped: boolean | null;
  fileCount: number | null;
  markForDelete: boolean;
  wasMissing: boolean;
  messageFromClientId: string | null;
  requestedByAgent: boolean | null;
  useId: boolean;
  notAttached: boolean;
  completed: boolean;
  parentId: string | null;
  fileData: string;
  raygunNotDownloadedErrorSent: boolean;
  instructions: string;
  matterId: string | null;
  hash: string;
}

export class ClientDocumentHelper {
  public static getStatus(document: ClientDocument) {
    if (!document.fileId && !document.completed && !document.rejectedByAgent && !document.rejectionReason) {
      return 'other';
    }
    else if (document.completed || document.timeUploaded || document.receivedOutsidePortal) {
      return 'complete';
    }
    else if (document.rejectedByAgent || document.rejectionReason) {
      return 'rejected';
    }

    return 'incomplete';
  }
}

export interface DocumentChildrenMap { [parentId: string]: ClientDocument[] };

